import Vue from 'vue'
import VueTkUI from '@moke/vue-tkui'
import '../assets/js/axios'
import filters from '../assets/js/filters'
import mixin from '../assets/js/mixin'
import '@moke/vue-tkui/src/sass/all.scss'
import myHeader from '@/components/myHeader'
import greyHeader from '@/components/greyHeader'
import gradientHeader from '@/components/gradientHeader'
import infiniteList from '@/components/infiniteList'
import emptyTips from '@/components/emptyTips'
import card from '@/components/card'
import tkCard from '@/components/tkCard'
import actionButton from '@/components/actionButton'
// 初始化tkUI
Vue.use(VueTkUI)
Vue.component('myHeader', myHeader)
Vue.component('greyHeader', greyHeader)
Vue.component('gradientHeader', gradientHeader)
Vue.component('infiniteList', infiniteList)
Vue.component('emptyTips', emptyTips)
Vue.component('card', card)
Vue.component('tkCard', tkCard)
Vue.component('actionButton', actionButton)
// 全局filter
for (let name in filters) {
  Vue.filter(name, filters[name])
}
// mixin
Vue.mixin(mixin)
